import React from 'react'
import Grid from '@mui/material/Grid'
import Radio from '../../../common/Radio'
import RadioGroup from '@mui/material/RadioGroup'
import FormControlLabel from '@mui/material/FormControlLabel'
import FormControl from '@mui/material/FormControl'
import TextField from '../../../common/TextField'
import Switch from '../../../common/Switch'
import Tooltip from '../../../common/Tooltip'
import { ReactComponent as AddNewIcon } from '../../../../assets/add-new.svg'

import Collapse from '@mui/material/Collapse'
import DeleteIcon from '@mui/icons-material/Delete'
import Paper from '@mui/material/Paper'
import { CompactPicker } from 'react-color'
import { IconButton } from '@mui/material'
import SingleSelect from '../../../common/SingleSelect'
import Button from '../../../common/Button'
// import ReportIcon from '@mui/icons-material/Report';
// import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import VerifiedUserIcon from '@mui/icons-material/VerifiedUser';
import ErrorIcon from '@mui/icons-material/Error';
import { useSelector } from 'react-redux'

// import WarningIcon from '@mui/icons-material/Warning';
const Modal = props => {
  const logInUser=useSelector((state)=>state.logInUsers)
           const hasPhone = Boolean(logInUser.phone);

  const paperStyle = {
    background: 'none',
    marginBottom: 5,
    paddingTop: 0,
    paddingBottom: 0
  }
  let createdCommands=[];
  props&&props.commands.map(e => {
    createdCommands.push({
      id: e.id,
      key: e.id,
      name: e.description,
      valueType: 'string',
    })}
  )
  return (
    <div style={{ padding: 20, minHeight: 270 }}>
      
      <Grid sm={5} xs={12}>
        <Paper
          className={' ' + (props.isOpenWebSection ? 'opened' : '')}
          style={paperStyle}
          elevation={0}
        >
          <h4
            className='page-title-notification'
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent:"flex-start",
              margin: 0,
              padding: 0
            }}
          >
            <span style={{marginRight:"18%"}}>{props.translate('webPopUp')}</span>
            <FormControlLabel
              style={{ marginLeft: 'auto' }}
              control={
                <Switch
                  checked={props.isOpenWebSection}
                  onChange={() => props.handleClick('isOpenWebSection')}
                  name='checkedA'
                />
              }
              label={
                props.isOpenWebSection
                  ? props.translate('enable')
                  : props.translate('disable')
              }
              labelPlacement='start'
              classes={{ label: 'color-inherit' }}
            />
          </h4>
          <Collapse in={props.isOpenWebSection}>
            <Grid container>
              {/* <Grid item xs={12}>
                <TextField
                  id='selectSound'
                  label={props.translate('selectSound')}
                  //required={true}
                  placeholder=''
                  value={props.form.alertSound}
                  onChange={e => props.handleChange('alertSound', e)}
                  variant='outlined'
                  margin='dense'
                  fullWidth
                  disabled={!props.isOpenWebSection}
                />
              </Grid> */}
              <Grid item xs={12}>
                <div style={{ marginBottom: 16 }}>
                  <label>{props.translate('selectColor')}</label>
                  <div
                    className='colorPicker-trigger'
                    style={{
                      background:
                        props.form && props.form.alertColor
                          ? props.form.alertColor
                          : 'red',
                      display: 'inline-block',
                      width: 18,
                      height: 18,
                      marginLeft: 10,
                      verticalAlign: 'middle',
                      position: 'relative',
                      zIndex: 9,
                      borderRadius: '50%',
                      pointerEvents: props.isOpenWebSection ? 'auto' : 'none'
                    }}
                    onClick={props.showColorPicker}
                  >
                    {props.colorPicker && (
                      <div
                        style={{ position: 'absolute', top: 0, left: '-50%' }}
                        onMouseLeave={props.hideColorPicker}
                      >
                        <CompactPicker
                          color={props.form.alertColor}
                          onChangeComplete={props.updateColor}
                          //disabled={!props.isOpenWebSection}
                        />
                      </div>
                    )}
                  </div>
                </div>
              </Grid>
            </Grid>
          </Collapse>
        </Paper>
      </Grid>
      <Grid sm={5} xs={12}>
        <Paper className='' style={paperStyle} elevation={0}>
          <h4
            className='page-title-notification'
            style={{
              display: 'flex',
              alignItems: 'center',
              margin: 0,
              padding: 0
            }}
          >
            <span style={{marginRight:"20.5%"}}>{props.translate('mobileNotifications')}</span>
            <FormControlLabel
              style={{ marginLeft: 'auto' }}
              control={
                <Switch
                  checked={props.isOpenFirebaseSection}
                  onChange={() => props.handleClick('isOpenFirebaseSection')}
                  name='checkedA'
                />
              }
              label={
                props.isOpenFirebaseSection
                  ? props.translate('enable')
                  : props.translate('disable')
              }
              labelPlacement='start'
              classes={{ label: 'color-inherit' }}
            />
          </h4>
        </Paper>
      </Grid>
      
      {/* <Grid sm={4} xs={12}>
        <Paper
          className={' ' + (props.isOpenSmsSection ? 'opened' : '')}
          style={paperStyle}
          elevation={0}
        >
          <h4
            className='page-title-notification'
            style={{
              display: 'flex',
              alignItems: 'center',
              margin: 0,
              padding: 0
            }}
          >
            <span>{props.translate('SMS')}</span>
            <FormControlLabel
              style={{ marginLeft: 'auto' }}
              control={
                <Switch
                  checked={props.isOpenSmsSection}
                  onChange={() => props.handleClick('isOpenSmsSection')}
                  name='isOpenSmsSection'
                />
              }
              label={
                props.isOpenSmsSection
                  ? props.translate('enable')
                  : props.translate('disable')
              }
              labelPlacement='start'
              classes={{ label: 'color-inherit' }}
            />
          </h4>
          <Collapse in={props.isOpenSmsSection}>
            <Grid container>
              <Grid item xs={12}>
                {props.form.number.map(item => {
                  return (
                    <div style={{ display: 'flex' }} key={item.id}>
                      <TextField
                        id='number'
                        label={props.translate('commandPhone')}
                        placeholder=''
                        value={item.text || ''}
                        onChange={e => props.handleChange('number', e, item.id)}
                        variant='outlined'
                        margin='dense'
                        fullWidth
                        disabled={!props.isOpenSmsSection}
                      />
                      {item.id === props.form.number.length && (
                        <Tooltip title={props.translate('addAnother')}>
                          <span>
                            <IconButton
                              color='inherit'
                              aria-label='directions'
                              onClick={e => props.onAddAnotherMail('number')}
                              disabled={!props.isOpenSmsSection}
                            >
                              <AddNewIcon
                                width={18}
                                height={18}
                                style={{ fill: 'currentColor' }}
                              />
                            </IconButton>
                          </span>
                        </Tooltip>
                      )}
                      {item.id < props.form.number.length && (
                        <Tooltip title={props.translate('addAnother')}>
                          <span>
                            <IconButton
                              color='inherit'
                              aria-label='directions'
                              onClick={e => props.deleteMail('number', item.id)}
                              disabled={!props.isOpenSmsSection}
                            >
                              <DeleteIcon
                                width={18}
                                height={18}
                                style={{ fill: 'currentColor' }}
                              />
                            </IconButton>
                          </span>
                        </Tooltip>
                      )}
                    </div>
                  )
                })}
              </Grid>
            </Grid>
          </Collapse>
        </Paper>
      </Grid> */}


      <Grid sm={5} xs={12}>
        <Paper
          className={' ' + (props.isOpenEmailSection ? 'opened' : '')}
          style={paperStyle}
          elevation={0}
        >
          <h4
            className='page-title-notification'
            style={{
              display: 'flex',
              alignItems: 'center',
              margin: 0,
              padding: 0
            }}
          >
            <span style={{marginRight:"23%"}}>{props.translate('emails')}</span>
            <FormControlLabel
              style={{ marginLeft: 'auto' }}
              control={
                <Switch
                  checked={props.isOpenEmailSection}
                  onChange={() => props.handleClick('isOpenEmailSection')}
                  name='isOpenEmailSection'
                />
              }
              label={
                props.isOpenEmailSection
                  ? props.translate('enable')
                  : props.translate('disable')
              }
              labelPlacement='start'
              classes={{ label: 'color-inherit' }}
            />
          </h4>
          <Collapse in={props.isOpenEmailSection}>
            <Grid container spacing={1}>
              <Grid item xs={12}>
                <FormControl
                  component='fieldset'
                  style={{ width: 'max-content' }}
                >
                  <RadioGroup
                    row
                    aria-label='position'
                    name='position'
                    value={props.form.mailTo||"user"}
                    onChange={e => props.handleChange('mailTo', e)}
                    // style={{marginLeft:"-5%"}}
                  >
                    <FormControlLabel
                      classes={{
                        label: 'form-contol-label'
                      }}
                      value='user'
                      control={<Radio size='small'  sx={{
                        color:props.themecolors?.textColor,
                        '&.Mui-checked': {
                          color: props.themecolors?.textColor,
                        },
                      }}/>}
                      label={props.translate('userEmail')}
                      labelPlacement='end'
                      disabled={!props.isOpenEmailSection}
                    />
                    <FormControlLabel
                      classes={{
                        label: 'form-contol-label'
                      }}
                      value='custom'
                      control={<Radio size='small'  sx={{
                        color:props.themecolors?.textColor,
                        '&.Mui-checked': {
                          color: props.themecolors?.textColor,
                        },
                      }}/>}
                      label={props.translate('customEmails')}
                      labelPlacement='end'
                      disabled={!props.isOpenEmailSection}
                    />
                    {/* <FormControlLabel
                        classes={{
                          label: 'form-contol-label'
                        }}
                        value='both'
                        control={<Radio />}
                        label={props.translate('BOTH')}
                        labelPlacement='end'
                         disabled={!props.isOpenEmailSection}
                      /> */}
                  </RadioGroup>
                </FormControl>
              </Grid>
          
             
              {props.form.mailTo !== 'user' &&  (
                <Grid item xs={6}>
                 {Array.isArray(props.form.email)&&props.form.email.map((item, index) => {
                  const isValidMail = props.validMail[index];
                  return (
                    <Grid container spacing={2} key={item.id}>
                       <Grid item xs={6} style={{display:"flex", justifyContent:"flex-start", alignItems:"center"}}>
                      <TextField
                        id='email'
                        label={props.translate('userEmail')}
                        placeholder=''
                        value={item.text || ''}
                        onChange={(e) => props.handleChange('email', e, item.id)}
                        disabled={!props.isOpenEmailSection}
                        variant='outlined'
                        margin='dense'
                        fullWidth
                      />
                    </Grid>
                    

                    <Grid item xs={1} style={{display:"flex", justifyContent:"flex-start", alignItems:"center"}}>
                      {item.id === props.form.email.length && (
                        <Tooltip title={props.translate('addAnother')}>
                          <span>
                            <IconButton
                              color='inherit'
                              aria-label='directions'
                              onClick={() => props.onAddAnotherMail('email', index)}
                              disabled={!props.isOpenEmailSection}
                            >
                              <AddNewIcon
                                width={18}
                                height={18}
                                style={{ fill: 'currentColor' }}
                              />
                            </IconButton>
                          </span>
                        </Tooltip>
                      )}
                    </Grid>



             
                    <Grid item xs={1}  style={{display:"flex", justifyContent:"flex-start", alignItems:"center"}}>
                      {1 < props.form.email.length && (
                        <Tooltip title={props.translate('delete')}>
                          <span>
                            <IconButton
                              color='inherit'
                              aria-label='directions'
                              onClick={() => props.deleteMail('email', item.id)}
                              disabled={!props.isOpenEmailSection}
                            >
                              <DeleteIcon
                                width={18}
                                height={18}
                                style={{ fill: 'currentColor' }}
                              />
                            </IconButton>
                          </span>
                        </Tooltip>
                      )}
                      </Grid>
                  


                    <Grid item xs={1}  style={{display:"flex", justifyContent:"flex-start", alignItems:"center"}}>
                      {isValidMail === true ? (
                        <Tooltip title={props.translate('alreadyVerified')}>
                          <span>
                            <IconButton
                              color='default'
                              aria-label='directions'
                              disabled={!props.isOpenEmailSection}
                              style={{ color: 'lightGreen' }}
                            >
                              <VerifiedUserIcon
                                width={30}
                                height={22}
                                // color="green"
                              />
                            </IconButton>
                          </span>
                        </Tooltip>
                      // ) :  isValidMail === false ? (
                        ) :  (
                        <Tooltip title={props.translate('unVerified')}>
                          <span>
                            <IconButton
                              color='default'
                              aria-label='directions'
                              disabled={!props.isOpenEmailSection}
                              // style={{ color: 'e' }}
                                // color="error"
                            >
                              <ErrorIcon
                                  width={30}
                                  height={22}
                                 color="error"
                              />
                            </IconButton>
                          </span>
                        </Tooltip>
                      ) }
                    </Grid>

                    {props.validateSingleEmail(item.text)?
                    <Grid item xs={3} style={{display:"flex", justifyContent:"flex-end", alignItems:"center"}}>
                      
                    {!isValidMail && (
                     <Button onClick={() => props.submitValidEmail(item.text)}>{props.translate('validate')}  </Button> 
                    )}
                    </Grid>:null}


                    </Grid>
                  );
                })}

                </Grid>
              )}
              {/* <Grid item xs={12}>
                <TextField
                  id='emailTemplate'
                  label={props.translate('emailTemplate')}
                  //required={true}
                  multiline
                  rows={5}
                  rowsMax={20}
                  placeholder=''
                  value={props.form.emailTemplate}
                  onChange={e => props.handleChange('emailTemplate', e)}
                  variant='outlined'
                  margin='dense'
                  fullWidth
                />
              </Grid> */}
            </Grid>
          </Collapse>
        </Paper>
      </Grid>
            <Grid sm={5} xs={12}>
        <Paper
          className={' ' + (props.isOpenUserSection ? 'opened' : '')}
          style={paperStyle}
          elevation={0}
        >
          <h4
            className='page-title-notification'
            style={{
              display: 'flex',
              alignItems: 'center',
              margin: 0,
              padding: 0
            }}
          >
            <span style={{marginRight:"24%"}}>{props.translate('SMS')}</span>
            <FormControlLabel
              style={{ marginLeft: 'auto' }}
              control={
                <Switch
                  checked={props.isOpenUserSection}
                  onChange={() => props.handleClick('isOpenUserSection')}
                  name='isOpenUserSection'
                />
              }
              label={
                props.isOpenUserSection
                  ? props.translate('enable')
                  : props.translate('disable')
              }
              labelPlacement='start'
              classes={{ label: 'color-inherit' }}
            />
          </h4>
          <Collapse in={props.isOpenUserSection}>
            <Grid container spacing={1}>
              <Grid item xs={12}>
                <FormControl
                  component='fieldset'
                  style={{ width: 'max-content' }}
                >
                  <RadioGroup
                    row
                    aria-label='position'
                    name='position'
                    value={props.form.smsTo||"user"}
                    onChange={e => props.handleChange('smsTo', e)}
                    // style={{marginLeft:"-5%"}}
                  >
                    <FormControlLabel
                      classes={{
                        label: 'form-contol-label'
                      }}
                      value='user'
                      control={<Radio size='small'  sx={{
                        color:props.themecolors?.textColor,
                        '&.Mui-checked': {
                          color: props.themecolors?.textColor,
                        },
                      }}/>}
                      label={props.translate('userPhone')}
                      labelPlacement='end'
                      disabled={!props.isOpenUserSection}
                    />
                    <FormControlLabel
                      classes={{
                        label: 'form-contol-label'
                      }}
                      value='custom'
                      control={<Radio size='small'  sx={{
                        color:props.themecolors?.textColor,
                        '&.Mui-checked': {
                          color: props.themecolors?.textColor,
                        },
                      }}/>}
                      label={props.translate('customPhone')}
                      labelPlacement='end'
                      disabled={!props.isOpenUserSection}
                    />
                  </RadioGroup>
                </FormControl>
              </Grid>
                     {props.form.smsTo === 'user'&& (
                <Grid item xs={6}>
                    <Grid container spacing={2}>
                       <Grid item xs={6} style={{display:"flex", justifyContent:"flex-start", alignItems:"center"}}>
                        {!hasPhone?<p style={{paddingLeft:"0.9rem",margin:0}}>{props.translate('userPhoneNotRegistered')}</p>:

<TextField
  id="userPhone"
  label={props.translate('userPhone')}
  value={logInUser?.phone || ""}
  disabled
  variant="outlined"
  margin="dense"
  fullWidth
  helperText={
    logInUser?.phone
      ? props.translate('userRegisteredPhone')
      : props.translate('userPhoneNotRegistered')
  }
  FormHelperTextProps={{
    sx: {
      color: hasPhone? 'success.main' : 'error.main',
      fontSize: 12,
    }
  }}
/>
                        }


                    </Grid>
                    </Grid>
                    </Grid>
                    )}
             
              {props.form.smsTo === 'custom' &&  (
                <Grid item xs={6}>
                    <Grid container spacing={2}>
                       <Grid item xs={6} style={{display:"flex", justifyContent:"flex-start", alignItems:"center"}}>
                    <TextField
                          id='customPhone'
                          label={props.translate('customPhone')}
                          placeholder=''
                          value={props.form.phones || ''}
                          onChange={e =>
                            props.handleChange('phones', e)
                          }
                          disabled={!props.isOpenUserSection}
                          variant='outlined'
                          margin='dense'       
                          fullWidth
                        />
                    </Grid>
                    </Grid>
                    </Grid>
                    )}
                    </Grid>
          </Collapse>
        </Paper>
      </Grid>

      {props.expirationCommandCheck ? null :
       <Grid sm={5} xs={12}>
        <Paper
          className={' ' + (props.isOpenCommandSection ? 'opened' : '')}
          style={paperStyle}
          elevation={0}
        >
          <h4
            className='page-title-notification'
            style={{
              display: 'flex',
              alignItems: 'center',
              margin: 0,
              padding: 0
            }}
          >
            <span style={{marginRight:"26%"}}>{props.translate('sharedSavedCommands')}</span>
            <FormControlLabel
              style={{ marginLeft: 'auto' }}
              control={
                <Switch
                  checked={props.isOpenCommandSection}
                  onChange={() => props.handleClick('isOpenCommandSection')}
                  name='isOpenCommandSection'
                />
              }
              label={
                props.isOpenCommandSection
                  ? props.translate('enable')
                  : props.translate('disable')
              }
              labelPlacement='start'
              classes={{ label: 'color-inherit' }}
            />
          </h4>
          <Collapse in={props.isOpenCommandSection}>
            <Grid container>
              <Grid item xs={12}>
                <FormControl
                  component='fieldset'
                  style={{ width: 'max-content' }}
                >
                  <RadioGroup
                    row
                    aria-label='position'
                    name='position'
                    value={props.form.commandType||"command"}
                    onChange={e => props.handleChange('commandType', e)}
                    // style={{marginLeft:"-5%"}}
                  >
                    <FormControlLabel
                      classes={{
                        label: 'form-contol-label'
                      }}
                      value='command'
                      control={<Radio size='small'  sx={{
                        color:props.themecolors?.textColor,
                        '&.Mui-checked': {
                          color: props.themecolors?.textColor,
                        },
                      }}/>}
                      label={props.translate('sharedSavedCommands')}
                      labelPlacement='end'
                      disabled={!props.isOpenCommandSection}
                    />
                    <FormControlLabel
                      classes={{
                        label: 'form-contol-label'
                      }}
                      value='custom'
                      control={<Radio size='small'  sx={{
                        color:props.themecolors?.textColor,
                        '&.Mui-checked': {
                          color: props.themecolors?.textColor,
                        },
                      }}/>}
                      label={props.translate('commands.custom')}
                      labelPlacement='end'
                      disabled={!props.isOpenCommandSection}
                    />
                  </RadioGroup>
                </FormControl>
              </Grid>
              {props.form.commandType === 'command' && (
                <Grid item xs={12}>
                      <div style={{ display: 'flex',width:"41%" }} 
                      // key={item.id}
                      > 
                        <Grid item xs={12}>
                          <SingleSelect
                            array={createdCommands}
                            selectName='type'
                            label={'sharedType'}
                            value={
                              (props.form.commandId !== 0)
                                ? {
                                    key: props.form.commandId,
                                    id: props.form.commandId,
                                    value: props.form.commandId,
                                    label: props.form.commandName
                                  }
                                : ''
                            }
                            handleChange={
                              props.handleChange
                            }
                            canRemove={true}
                            canAssign={true}
                          />
                        </Grid>
                      </div>
                </Grid>
              )}
              {props.form.commandType === 'custom' && (
                <Grid item xs={12} >
                      <div style={{ display: 'flex',width:"41%" }} 
                      // key={item.id}
                      >
                        <TextField
                          id='command'
                          label={props.translate('commands.custom')}
                          placeholder=''
                          value={props.form.commandData || ''}
                          onChange={e =>
                            props.handleChange('commandData', e)
                          }
                          disabled={!props.isOpenCommandSection}
                          variant='outlined'
                          margin='dense'       
                          fullWidth
                        />
                      </div>
                </Grid>
              )}
            </Grid>
          </Collapse>
        </Paper>
      </Grid>
      }
      {/* <Grid item sm={6} xs={12}>
          <h4 className='page-title-notification'>{props.translate('mobile)}
           <Tooltip
              title={props.translate('openthisSectionWillBeConsiderSelection')}
            >
            <span
              style={{ verticalAlign: 'middle', display: 'inline-flex' }}
              onClick={() => props.handleClick('isOpenMobileSection')}
            >
              {props.isOpenMobileSection ? <ExpandLess /> : <ExpandMore />}
            </span>
            </Tooltip>
            </h4>
             <Collapse in={props.isOpenMobileSection} timeout='auto' unmountOnExit>
          <>
            <Grid item sm={6} xs={12}>
              <SearchDevices
                api='users'
                fill
                isClearable
                onChange={props.onChangedUsers}
                //value={props.deviceFullData}
              />
            </Grid>
          </>
           </Collapse>
        </Grid> */}
    </div>
  )
}
export default Modal
